import React, { useRef } from "react"

import useTracking from "hooks/useTracking"

import { StyledCard } from "./styles"

const ArticleCard = ({
  authors,
  category,
  clickPosition,
  id,
  pageSection,
  pageType,
  partner,
  previewImage,
  sponsor,
  subcategory,
  titles,
  tracking = ["Render", "View", "Click"],
  url,
  ...props
}) => {
  if (!id) {
    return null
  }

  const author = authors && authors[0]
  const collaborator = partner || sponsor
  const partnershipType = partner ? "Partner" : "Sponsor"

  const { track, trackRender, trackView } = useTracking()
  const ref = useRef(null)

  const trackingId = partner ? "partner_article" : sponsor ? "sponsor_article" : "article_card"
  const trackingProps = {
    page_type: pageType,
    page_section: pageSection,
    label: `${pageType} | ${pageSection}`,
    article_id: id,
    ...(collaborator &&
      (partner ? { partner_id: collaborator.partnerId } : { sponsor_id: collaborator.sponsorId })),
    category: "Content Engagement",
    content_category: category,
    content_subcategory: subcategory,
  }

  if (collaborator) {
    if (tracking.includes("Render")) {
      trackRender(ref, trackingId, trackingProps)
    }
    if (tracking.includes("View")) {
      trackView(ref, trackingId, trackingProps)
    }
  }

  // we handle trackClick event manually, because user can also click on a category link
  const handleClick = (event) => {
    if (tracking.includes("Click")) {
      let target = event.target

      while (target) {
        if (target.tagName === "A") {
          const { pathname } = new URL(target.href)
          if (pathname.startsWith("/articles")) {
            track("Element Clicked", {
              ...trackingProps,
              element_id: trackingId,
              click_title: titles.site || titles.body,
              click_url: `/articles/${url}`,
              click_position: clickPosition,
            })

            break
          }
        }

        target = target.parentNode
      }
    }
  }

  return (
    <StyledCard
      elRef={ref}
      headline={titles.site || titles.body}
      author={author ? author.name : "mindbodygreen"}
      link={`/articles/${url}`}
      localLink
      imageCrops={JSON.parse(previewImage)}
      lazyLoadImage={false}
      {...(collaborator && {
        author: author ? author.name || collaborator.name : collaborator.name,
        partnerName: collaborator.name,
        partnerUrl: `/partner/${collaborator.url}`,
        partnershipType,
      })}
      isGrid
      {...props}
      category={subcategory}
      onClick={handleClick}
    />
  )
}

export default ArticleCard
